<template>
    <v-card
        elevation="0"
        outlined
        class="pa-4"
        style="height: 100%; border-radius: 16px;"
    >   
        <v-row class="mx-0 mb-4 mt-0">
            <p class="txt ma-0" style="font-size: 16px;font-weight: 600;">{{ title }}</p>            
        </v-row>
        <v-row v-if="data.length === 0" class="d-flex align-center justify-center ma-0" style="height: 80%;">
            <span  class="not-result">No hay elementos para mostrar</span>
        </v-row>
        <div v-else>
            <div  class="ma-0 pa-0">
                <v-col xs="12" sm="12" lg="12" class="ma-0 px-5">
                    <div v-for="item in data" class="d-flex justify-space-between align-center" style="width: 100%;">
                        <p class="txt">{{ item.label }}</p>
                        <p class="subtxt">{{ item.total }}</p>
                    </div>
                </v-col>
            </div>
            <v-row class="ma-0 pa-0">
                <v-col xs="12" sm="12" lg="12" class="ma-0 px-5 d-flex justify-space-between align-center" style="width: 100%;">
                    <p class="txt font-weight-bold">Total</p>
                    <p class="subtxt">{{ total }}</p>
                </v-col>
            </v-row>
            
        </div>
    </v-card>
</template>

<script>
    export default {
        
        data(){
            return{
                total: 0
            }
        },
        props:{
            title:{
                required:true,
                default: "Titulo"
            },
            data:{
                required:true,
                default: []
            }
        },
        methods:{
            getTotal(){
                if(this.data.length > 0){
                    this.data.forEach(element => {
                        this.total += element.total
                    });
                }
            }
        },
        watch:{
            data:{
                handler(){
                    this.total = 0
                    this.getTotal()
                },
                deep:true,
                immediate:true
            }
        }
    }
</script>

<style scoped >
    .txt{
        margin-bottom: 8px;
        font-size: 12px;
        color: #6b7590;
        font-weight: 500;
        font-family: 'Montserrat'
    }
    .subtxt{
        margin-bottom: 8px;
        font-size: 12px;
        color: #1A2233;
        font-weight: 500;
    }
    .not-result{
        font-size: 14px;
        color: #6b7590;
        font-weight: 500;
        font-family: 'Montserrat';
        font-style: italic;
    }
</style>